import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { userPaymentMethodsReselector as stateSelector } from 'reduxModules/users/selectors'
import { paymentMethodListDispatchers as dispatchSelector } from 'reduxModules/users/dispatchers'
import PaymentMethod, { PaymentMethodStructure } from './PaymentMethod'
import './styles.css'

export class PaymentMethodList extends Component {
  componentDidMount() {
    this.props.loadPaymentMethods()
  }

  render() {
    const {
      paymentMethods,
      removePaymentMethodDispatcher,
      markPaymentDefault,
      markPaymentDefaultWithconfirmation,
      isSubscribed,
      showModal,
      isMobile
    } = this.props
    return (
      <div id="PaymentMethodList">
        {paymentMethods.map((paymentMethod) => (
          <PaymentMethod
            key={paymentMethod.token}
            remove={() => removePaymentMethodDispatcher(paymentMethod.token)}
            setDefault={() => markPaymentDefault(paymentMethod.token)}
            setDefaultWithConfirmation={() => markPaymentDefaultWithconfirmation(paymentMethod.token)}
            {...paymentMethod}
            isSubscribed={isSubscribed}
            openModal={showModal}
            isMobile={isMobile}
          />
        ))}
      </div>
    )
  }
}

PaymentMethodList.propTypes = {
  loadPaymentMethods: PropTypes.func.isRequired,
  paymentMethods: PropTypes.arrayOf(PropTypes.shape(PaymentMethodStructure)),
  removePaymentMethodDispatcher: PropTypes.func.isRequired,
  markPaymentDefault: PropTypes.func.isRequired,
  markPaymentDefaultWithconfirmation: PropTypes.func,
  isSubscribed: PropTypes.bool,
  showModal: PropTypes.func,
  isMobile: PropTypes.bool
}

PaymentMethodList.defaultProps = {
  paymentMethods: [],
  isMobile: false,
  markPaymentDefaultWithconfirmation: () => {},
  isSubscribed: false,
  showModal: () => {}
}

export default connect(
  stateSelector,
  dispatchSelector
)(PaymentMethodList)
